import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import { punditUserInvalidations } from "@circle-react/lib/queries/punditUser";
import { queryClient } from "@circle-react/providers/QueryClient/reactQueryConfig";

export const communityLinkKey = createQueryKeyFactory("community-link");

export const communityLinkInvalidations = {
  all: () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: communityLinkKey.root() }),
      punditUserInvalidations.all(),
    ]),
};
